import classnames from 'classnames';
import React from 'react';
import capitalizeString from 'utils/textHelpers/capitalizeString';
import AppleIcon from '~/reusable-components/icons/social/AppleIcon';
import FacebookIcon from '~/reusable-components/icons/social/FacebookIcon';
import GoogleColorIcon from '~/reusable-components/icons/social/GoogleColorIcon';

const CSS = require('./OAuthButton.less');

interface OAuthButtonProps {
  isLogin?: boolean;
  onClick: (provider: 'google' | 'facebook' | 'apple') => void;
  provider: 'google' | 'facebook' | 'apple';
  variant?: 'compact' | 'large';
  isLoading?: boolean;
  hasError?: boolean;
}

function OAuthButton({
  isLogin,
  onClick,
  provider,
  variant = 'compact',
  isLoading,
  hasError,
}: OAuthButtonProps) {
  const onButtonClick = () => onClick(provider);
  const buttonText = `${
    isLogin ? 'Continue' : 'Sign in'
  } with ${capitalizeString(provider)}`;

  return (
    <button
      className={classnames(CSS.Button, {
        [CSS.AppleButton]: provider === 'apple',
        [CSS.FacebookButton]: provider === 'facebook',
        [CSS.GoogleButton]: provider === 'google',
        [CSS.ButtonLoading]: isLoading,
        [CSS.ButtonFullWidth]: variant === 'large',
        [CSS.ButtonError]: hasError,
      })}
      onClick={onButtonClick}
      aria-label={buttonText}
    >
      {provider === 'google' && (
        <GoogleColorIcon className={CSS.Icon} width={24} height={24} />
      )}
      {provider === 'facebook' && (
        <FacebookIcon
          className={classnames(CSS.Icon, CSS.FacebookIcon)}
          width={30}
          height={30}
        />
      )}
      {provider === 'apple' && (
        <AppleIcon
          className={classnames(CSS.Icon, CSS.AppleIcon)}
          width={24}
          height={24}
        />
      )}
      {variant === 'large' && (
        <span className={CSS.ButtonText}>{buttonText}</span>
      )}
    </button>
  );
}

export default OAuthButton;
